export default __webpack_public_path__ + "static/media/Blackgrasp.5e4aa08c.jpg";